import { Route } from '@angular/router';
import { mgsAdminGuard } from '../mgs-guards';
import { ADMIN_SERVICES_PATH, ADMIN_SERVICES_TITLE } from '../mgs-path-defs';

export const adminServicesRoute: Route = {
  path: ADMIN_SERVICES_PATH,
  title: ADMIN_SERVICES_TITLE,
  canActivate: [mgsAdminGuard],
  loadComponent: () => import('./admin-services.component')
};
